module.exports = __webpack_public_path__ + "img/MINT.663c493c.svg";